import Dropdown from "../../gui/Dropdown/Dropdown";
import { UpdateEvent } from "../../gui/GUIEvents";
import Tooltip from "../../gui/Overlay/Tooltip";
import Loading from "../../gui/Loading/Loading";
import { useRecipes } from "../RecipesProvider";

export interface IFoodEntryListProps {
    index:number
    foodId:number|string
    onUpdate:(e:UpdateEvent<number|string>) => void
}
export default function FoodEntryList(props:IFoodEntryListProps){
    const {options} = useRecipes()
    if (options) return <Tooltip tooltip={""} className="food">
        <Dropdown anchorProps={{width:"match"}} canClear={false} options={options} placeholder="Food/Recipe" defaultValue={props.foodId} onUpdate={props.onUpdate}/>
    </Tooltip>
    else return <Loading/>
}